import * as ACTION_TYPES from '@actions/action_types'
import type { MessagesChannelInterface } from '@interfaces/messages'
export const initialState: MessagesChannelInterface = {
  title: null,
  message: null,
  status: null,
  url: null,
  payload: null,
}
const MessagesReducer = (
  state: MessagesChannelInterface,
  action: A,
): MessagesChannelInterface => {
  switch (action.type) {
    case ACTION_TYPES.SET_MESSAGES:
      return action.data
    default:
      return state
  }
}
export default MessagesReducer
